export default function encrypt({ el, directive, component, cleanup }) {
    let onBlur = async (e) => {
        let propertyName = el.getAttribute("name");
        let publicKey = component.$wire.$get("key");

        let plainText = el.value;

        if (!publicKey) {
            alert("Key Not available !!! cannot proceed further");
            return;
        }

        if (plainText == "") {
            Livewire.find(component.id).$set(propertyName, "", false);
            return;
        }

        try {
            //clean public key by removing characters
            let publicKeyCleaned = publicKey
                .replace(
                    /-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\n/g,
                    ""
                )
                .trim();

            // Convert the publicKey from Base64 to ArrayBuffer
            let keyBuffer = Uint8Array.from(atob(publicKeyCleaned), (c) =>
                c.charCodeAt(0)
            ).buffer;

            // Import the publicKey
            let cryptoKey = await window.crypto.subtle.importKey(
                "spki",
                keyBuffer,
                { name: "RSA-OAEP", hash: "SHA-1" },
                true,
                ["encrypt"]
            );

            // Encrypt the plainText using the publicKey
            let encryptedArrayBuffer = await window.crypto.subtle.encrypt(
                { name: "RSA-OAEP" },
                cryptoKey,
                new TextEncoder().encode(plainText)
            );

            // Convert the encrypted data to Base64
            let encryptedBase64 = btoa(
                String.fromCharCode.apply(
                    null,
                    new Uint8Array(encryptedArrayBuffer)
                )
            );

            component.$wire.$set(propertyName, encryptedBase64, false);
        } catch (error) {
            console.error("Javascript Not Working:", error);
        }
    };

    el.addEventListener("blur", onBlur, { capture: true });

    // Register any cleanup code inside `cleanup()` in the case
    // where a Livewire component is removed from the DOM while
    // the page is still active.
    cleanup(() => {
        el.removeEventListener("blur", onBlur);
    });
}
